import React, { Component } from 'react'

/** State depedencies */
import Logic from './logic'

/** Ui depedencies */
import { Row } from 'react-flexbox-grid'
import { Wrapper, Container } from './style'

import Results from 'containers/Results'
import Filters from 'containers/Filters'

@Logic
class App extends Component {
  render () {
    const { results, isCompany } = this.props

    return (
      <Wrapper>
        <Container fluid>
          <Filters isCompany={isCompany} />
          <Row>
            <Results results={results} isCompany={isCompany} />
          </Row>
        </Container>
      </Wrapper>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/containers/App/index.js